class GiftCardModal extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.closeButton = null;
    this.triggerButtons = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.modal = this.querySelector('.gift-card-modal');
    
    if (!this.modal) return;

    this.closeButton = this.modal.querySelector('.modal__close');
    this.triggerButtons = document.querySelectorAll('.gift-card-button');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.triggerButtons.forEach(button => {
      button.addEventListener('click', () => this.openModal());
    });
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeModal());
    }

    if (this.modal) {
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.closeModal();
        }
      });
    }
  }

  openModal() {
    if (this.modal) {
      this.modal.classList.add('is-open');
      document.body.style.overflow = 'hidden'; 
    }
  }

  closeModal() {
    if (this.modal) {
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  disconnectedCallback() {
    document.body.style.overflow = '';
  }
}

if (!customElements.get('gift-card-modal')) {
  customElements.define('gift-card-modal', GiftCardModal);
}
